import { adaptiveFontSize, getMobileMaxColumnWidth } from './helpers'

const previewKnownHeight = (parent, config) => {
    const { banner, name } = parent
    const { displayBanner } = config
    const height = (displayBanner ? banner.height : 0) + name.height
    return height
}

export const DESKTOP_PREVIEW_STYLES = {
    sm: {
        preview: {
            seeAll: {
                fontSize: 15,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: 225,
            },
            avatar: {
                size: 40,
            },
            utilities: {
                iconSize: 0.7,
            },
            viewers: {
                iconSize: 0.47,
                fontSize: 10,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                },
                priorMissMFC: {
                    height: 10.5,
                    width: 10.5,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                height: 20,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 10 }),
                fontSizeMinimum: 9.7,
                height: 20,
            },
            _knownHeight: previewKnownHeight,
        },
    },
    md: {
        preview: {
            seeAll: {
                fontSize: 16,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: 300,
            },
            avatar: {
                size: 55,
            },
            utilities: {
                iconSize: 0.8,
            },
            viewers: {
                fontSize: 10.5,
                iconSize: 0.5,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.6,
                    fontSize: 8,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 8,
                },
                priorMissMFC: {
                    height: 12,
                    width: 12,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9.4,
                height: 24,
            },
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 12.7,
                height: 24,
            },
            _knownHeight: previewKnownHeight,
        },
    },
    lg: {
        preview: {
            seeAll: {
                fontSize: 17,
            },
            title: {
                fontSize: 19,
            },
            column: {
                maxWidth: 450,
            },
            utilities: {
                iconSize: 0.9,
            },
            viewers: {
                iconSize: 0.6,
                fontSize: 12,
                offsetY: 0,
            },
            avatar: {
                size: 70,
            },
            badge: {
                status: {
                    iconSize: 0.8,
                    fontSize: 9,
                    offsetX: 6,
                    offsetY: 6,
                },
                newMissMFC: {
                    fontSize: 9,
                },
                priorMissMFC: {
                    height: 16.5,
                    width: 16.5,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.8,
                fontSize: 14,
                height: 28,
            },
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 18,
                height: 40,
            },
            _knownHeight: previewKnownHeight,
        },
    },
}

export const MOBILE_PREVIEW_STYLES = {
    sm: {
        preview: {
            seeAll: {
                fontSize: 9.5,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(3),
            },
            avatar: {
                size: 30,
            },
            utilities: {
                iconSize: 0.5,
            },
            viewers: {
                iconSize: 0.45,
                fontSize: 9,
                offsetY: 1,
            },
            badge: {
                status: {
                    iconSize: 0.35,
                    fontSize: 6,
                    offsetX: 3,
                    offsetY: 3,
                },
                newMissMFC: {
                    fontSize: 6,
                    margin: 1,
                },
                priorMissMFC: {
                    height: 8,
                    width: 9,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views per minute',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.4,
                fontSize: 7,
                height: 16,
            },
            roomIconOffset: 2,
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 9.7,
                height: 20,
            },
            _knownHeight: previewKnownHeight,
        },
    },
    md: {
        preview: {
            seeAll: {
                fontSize: 12.5,
            },
            title: {
                fontSize: 16,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(2),
            },
            avatar: {
                size: 40,
            },
            utilities: {
                iconSize: 0.7,
            },
            viewers: {
                iconSize: 0.45,
                fontSize: 9.7,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 2,
                },
                priorMissMFC: {
                    height: 12,
                    width: 13,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views per minute',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.4,
                fontSize: 8,
                height: 20,
            },
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 12.7,
                height: 24,
            },
            _knownHeight: previewKnownHeight,
        },
    },
    lg: {
        preview: {
            seeAll: {
                fontSize: 14,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(1),
            },
            avatar: {
                size: 60,
            },
            utilities: {
                iconSize: 0.8,
            },
            viewers: {
                fontSize: 10.5,
                iconSize: 0.5,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.7,
                    fontSize: 7,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 3,
                },
                priorMissMFC: {
                    height: 17,
                    width: 18,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 2px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                height: 24,
            },
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 16.7,
                center: true,
                height: 28,
            },
            _knownHeight: previewKnownHeight,
        },
    },
}
